import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Navigation } from "./components/navigation";
import About from "./components/about";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});
const RemoveTrailingSlash = () => {
  const location = useLocation();
  if (location.pathname.endsWith('/') && location.pathname !== '/') {
    return <Navigate to={location.pathname.slice(0, -1)} replace />;
  }
  return null;
};
const App = () => {
  return (
    <Router>
      <RemoveTrailingSlash />
      <div>
        <Navigation />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
